























































import { Vue, Component } from 'vue-property-decorator'
@Component
export default class WaitListThankYouPage extends Vue {
  async logout() {
    await this.authService.logout()
    this.$router.push('/login')
  }
}
